import React, { useState } from 'react';
import {
    Table,
    Tbody,
    Tr,
    Th,
    Td,
    Thead,
    Box,
} from '@chakra-ui/react';
import {  FaFileDownload, FaTrash } from 'react-icons/fa';
import Pagination from 'react-bootstrap/Pagination';
import { formatAmountInINR } from 'jsFunctions/formatAmountInINR';
import moment from 'moment';

const QuotationTable = ({ quotations, handlePreview, handleDelete }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 3; // Adjust items per page as needed

    // Calculate pagination details
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = quotations.slice(indexOfFirstItem, indexOfLastItem);
    const pageCount = Math.ceil(quotations.length / itemsPerPage);

    return (
      <>
        <div>
          <Box overflowX="auto">
            <Box mb={4}>
                <h3 className='quotation-heading'>Quotation List</h3>
              <Table className="quotation-table">
                <Thead>
                  <Tr>
                    <Th width={1}>No.</Th>
                    <Th width={160}>Amount</Th>
                    <Th width={200}>Created At</Th>
                    <Th width={100}>Files</Th>
                    <Th width={500}>Remarks</Th>
                    <Th width={10}>Action</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {currentItems.map((quotation, index) => (
                    <Tr>
                      <Td>{indexOfFirstItem + index + 1}</Td>
                      <Td>{formatAmountInINR(quotation.amt || 0)}</Td>
                      <Td>{moment(quotation?.crAt).format("DD-MMM-YYYY")}</Td>
                      <Td>
                        <Box display="flex" paddingLeft={2}>
                          {quotation?.fils?.length > 0
                            ? quotation.fils.map((file, fileIndex) => (
                               
                                  <FaFileDownload 
                                  onClick={() =>
                                    handlePreview(file.key, file?.spId)
                                  }
                                  className="mx-1"
                                  style={{
                                    fontSize: "16px",
                                    cursor: "pointer",
                                  }}
                                  />
                              ))
                            : <span className='mx-3'>-</span>}
                        </Box>
                      </Td>
                      <Td>{quotation.rmks || '-'}</Td>
                      <Td>
                        <FaTrash
                          style={{
                            fontSize: "16px",
                            color: "#8f1402",
                            cursor: "pointer",
                          }}
                          className="mx-3"
                          onClick={() => handleDelete("", quotation._id)}
                        />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Box>
          </Box>

          {/* Pagination Component */}
          <Pagination
            className="justify-content-end"
            style={{ marginTop: "20px" }}
          >
            <Pagination.Prev
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            />
            {Array.from({ length: pageCount }, (_, i) => (
              <Pagination.Item
                key={i + 1}
                active={i + 1 === currentPage}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, pageCount))
              }
              disabled={currentPage === pageCount}
            />
          </Pagination>
        </div>
      </>
    );
};

export default QuotationTable;
